// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
    errorMessage: null,
    successMessage: null,
    isLoading: false,
    batches: null,
    isBatchesLoading: true,
    lines: null,
    stockBatches: null,
    stockLines: null,
    isPSkuLoading: false,
    isImportLoading: false,
    isImportCompleted: false,
};

/* Generic error message */
const genericError = "Something went wrong";

/* GET batches */
export const getAsnBatchesImport = (state: Object = INITIAL_STATE) => {
    return {
        ...state,
        isBatchesLoading: true,
        successMessage: null,
        errorMessage: null
    };
};

export const getAsnBatchesImportSuccess = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    const successMessage = "Transfer success";
    return {
        ...state,
        batches: action.batches,
        successMessage,
        isBatchesLoading: false
    };
};

export const getAsnBatchesImportFailure = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    return {
        ...state,
        isBatchesLoading: false,
        errorMessage: action.errorMessage || genericError
    };
};

/* GET STOCK BATCHES */
export const getAsnBatchesStock = (state: Object = INITIAL_STATE) => {
    return {
        ...state,
        isBatchesLoading: true,
        successMessage: null,
        errorMessage: null
    };
};

export const getAsnBatchesStockSuccess = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    const successMessage = "Transfer success";
    return {
        ...state,
        stockBatches: action.stockBatches,
        successMessage,
        isBatchesLoading: false
    };
};

export const getAsnBatchesStockFailure = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    return {
        ...state,
        isBatchesLoading: false,
        errorMessage: action.errorMessage || genericError
    };
};

/* GET PROCESSED LINES */
export const getImportLines = (state: Object = INITIAL_STATE, action) => {
    return {
        ...state,
        isLoading: !action.isExport,
        successMessage: null,
        errorMessage: null,
        isExporting: action.isExport
    };
};

export const getImportLinesSuccess = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    const successMessage = "Transfer success";
    const val = {
        ...state,
        successMessage,
        isLoading: false,
        isExporting: false
    };
    if (!state.isExporting) {
        val.lines = action.lines;
    }

    return val;
};

export const getImportLinesFailure = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    return {
        ...state,
        errorMessage: action.errorMessage || genericError,
        isLoading: false
    };
};

/* GET PROCESSED STOCK LINES */
export const getStockLines = (state: Object = INITIAL_STATE, action) => {
    return {
        ...state,
        //isLoading: !action.isExport,
        successMessage: null,
        errorMessage: null,
        isExporting: action.isExport
    };
};

export const getStockLinesSuccess = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    const successMessage = "Transfer success";
    const val = {
        ...state,
        successMessage,
        isLoading: false,
        isExporting: false
    };
    if (!state.isExporting) {
        val.stockLines = action.stockLines;
    }

    return val;
};

export const getStockLinesFailure = (
    state: Object = INITIAL_STATE,
    action: Object
) => {
    return {
        ...state,
        errorMessage: action.errorMessage || genericError,
        isLoading: false
    };
};

/* Export Offers */
export const exportStock = state => {
  return {
    ...state,
    isPSkuLoading: true
  };
};

export const exportStockSuccess = state => {
  return {
    ...state,
    isPSkuLoading: false
  };
};

export const exportStockFailure = (state, action) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isPSkuLoading: false
  };
};

/*  importPSkuUnique */
export const importStock = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isImportLoading: true,
    successMessage: null,
    errorMessage: null,
    isImportCompleted: false
  };
};

export const importStockSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Offers imported successfully";
  return {
    ...state,
    successMessage,
    documentBatchId: action.documentBatchId,
    isImportLoading: false,
    isImportCompleted: true
  };
};

export const importStockFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isImportLoading: false,
    isImportCompleted: true
  };
};

const ACTION_HANDLERS = {
    [Types.GET_ASN_BATCHES_IMPORT]: getAsnBatchesImport,
    [Types.GET_ASN_BATCHES_IMPORT_SUCCESS]: getAsnBatchesImportSuccess,
    [Types.GET_ASN_BATCHES_IMPORT_FAILURE]: getAsnBatchesImportFailure,
    [Types.GET_IMPORT_LINES]: getImportLines,
    [Types.GET_IMPORT_LINES_SUCCESS]: getImportLinesSuccess,
    [Types.GET_IMPORT_LINES_FAILURE]: getImportLinesFailure,
    [Types.GET_ASN_BATCHES_STOCK]: getAsnBatchesStock,
    [Types.GET_ASN_BATCHES_STOCK_SUCCESS]: getAsnBatchesStockSuccess,
    [Types.GET_ASN_BATCHES_STOCK_FAILURE]: getAsnBatchesStockFailure,
    [Types.GET_STOCK_LINES]: getStockLines,
    [Types.GET_STOCK_LINES_SUCCESS]: getStockLinesSuccess,
    [Types.GET_STOCK_LINES_FAILURE]: getStockLinesFailure,
    [Types.EXPORT_STOCK]: exportStock,
    [Types.EXPORT_STOCK_SUCCESS]: exportStockSuccess,
    [Types.EXPORT_STOCK_FAILURE]: exportStockFailure,
    [Types.IMPORT_STOCK]: importStock,
    [Types.IMPORT_STOCK_SUCCESS]: importStockSuccess,
    [Types.IMPORT_STOCK_FAILURE]: importStockFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/ImportReducer.js